export default __webpack_public_path__ + "static/tridyme-default-image-7672244a69e883748822a885c15de5e4.png";